<table *ngIf="tableData?.length > 0" class="w-full text-left rounded shadow rtl:text-right text-gray-500">
	<thead class="semi-bold sticky top-0 z-10 text-xs bg-white text-black">
		<tr>
			<th *ngIf="isUnclaimedTable" class="px-2 py-2"></th>
			<th (click)="handleSortClick.emit({ column: 'TicketTypeName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Type
				<i [class]="getSortIconClass('TicketTypeName')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'ClientName', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Client
				<i [class]="getSortIconClass('ClientName')" class="ml-1"></i>
			</th>
			<th
				*ngIf="!isUnclaimedTable"
				(click)="handleSortClick.emit({ column: 'AssignedToUserName', direction: sortConfig.direction })"
				class="px-2 py-2 cursor-pointer"
			>
				Assigned To
				<i [class]="getSortIconClass('AssignedToUserName')" class="ml-1"></i>
			</th>
			<th
				*ngIf="!isUnclaimedTable"
				(click)="handleSortClick.emit({ column: 'TicketStateName', direction: sortConfig.direction })"
				class="px-2 py-2 cursor-pointer"
			>
				Status
				<i [class]="getSortIconClass('TicketStateName')" class="ml-1"></i>
			</th>
			<th
				*ngIf="!isUnclaimedTable"
				(click)="handleSortClick.emit({ column: 'ReminderTime', direction: sortConfig.direction })"
				class="px-2 py-2 cursor-pointer"
			>
				Reminder Time
				<i [class]="getSortIconClass('ReminderTime')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'LastTicketActionDate', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Last Action
				<i [class]="getSortIconClass('LastTicketActionDate')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'IsHighPriority', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				High Priority
				<i [class]="getSortIconClass('IsHighPriority')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'Title', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Summary
				<i [class]="getSortIconClass('Title')" class="ml-1"></i>
			</th>
			<th (click)="handleSortClick.emit({ column: 'LocationCount', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Locations
				<i [class]="getSortIconClass('LocationCount')" class="ml-1"></i>
			</th>
			<th *ngIf="!isUnclaimedTable" (click)="handleSortClick.emit({ column: 'CreatedDate', direction: sortConfig.direction })" class="px-2 py-2 cursor-pointer">
				Created
				<i [class]="getSortIconClass('CreatedDate')" class="ml-1"></i>
			</th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="
				let ticket of tableData
					| paginate
						: {
								itemsPerPage: 25,
								currentPage: viewStateService.pageNumber,
								totalItems: totalItems
						  }
			"
			class="border-b text-[12px] xl:text-sm text-black cursor-pointer hover:opacity-90"
			(click)="onRowSelect(ticket)"
			[ngClass]="ticket.rowBgColor"
		>
			<td *ngIf="isUnclaimedTable" class="py-2 px-2">
				<button
					(click)="handleTakeClick(ticket)"
					class="px-2 !w-auto text-black bg-gray-200 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm py-2.5 me-2"
				>
					Take
				</button>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">
					{{ ticket.TicketTypeName }}
				</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center semi-bold">{{ ticket.ClientName }}</p>
			</td>

			<td *ngIf="!isUnclaimedTable" class="py-2 px-2">
				<p class="flex items-center">
					{{ ticket.AssignedToUserName }}
				</p>
			</td>
			<td *ngIf="!isUnclaimedTable" class="py-2 px-2">
				<p class="flex items-center">{{ ticket.TicketStateName }}</p>
			</td>
			<td *ngIf="!isUnclaimedTable" class="py-2 px-2">
				<p class="flex items-center">{{ (ticket.ReminderTime | date : 'M/d/yyyy') ?? 'N/A' }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ ticket.lastActionDateView }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ ticket.IsHighPriority }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ ticket.Title }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center">{{ ticket.LocationCount }}</p>
			</td>
			<td *ngIf="!isUnclaimedTable" class="py-2 px-2">
				<p class="flex items-center">{{ ticket.CreatedDate | date : 'M/d/yyyy' }}</p>
			</td>
		</tr>
	</tbody>
</table>
<div *ngIf="tableData?.length === 0" class="text-center text-gray-500">
	<p>Nothing here.</p>
</div>
<div *ngIf="tableData?.length > 0" class="flex justify-between items-center mx-4 mt-2 mb-[100px]">
	<div>
		<pagination-controls (pageChange)="handlePaginationClick.emit($event)" class="pagination"></pagination-controls>
		<input class="h-10 !w-16 mr-4" [(ngModel)]="viewStateService.pageNumber" (input)="handlePaginationClick.emit()" />
	</div>
	<div *ngIf="viewStateService.mainTableTotalItems">
		<span class="semi-bold">Total Items:</span>
		{{ totalItems }}
	</div>
</div>
